<template>
  <body>
    <main class="d-flex align-items-center min-vh-100 py-3 py-md-0">
      <div class="container">
        <div class="card login-card">
          <div class="bg-primary bg-soft">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary" style="font-weight: 600">
                    Daftar Penjual
                  </h5>
                  <p>Daftar Penyedia SIPLah Eureka</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="../assets/upload/office.png"
                  alt="..."
                  id="pictureOffice"
                  class="p-3"
                  width="50%"
                  style="margin: 10px 0px 0px 130px"
                />
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="auth-logo">
              <a href="#" class="auth-logo-light">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      src="../assets/upload/market.png"
                      alt="..."
                      class="rounded-circle"
                      height="40"
                    />
                  </span>
                </div>
              </a>
            </div>
            <!-- <div class="text-center">
              <img
                class="img-container"
                src="https://siplah.eurekabookhouse.co.id/assets/image/kemdikbud_anim.gif"
                height="50px"
              />
              <p class="login-card-description text-center">
                Daftar Penyedia SIPLah <br />
                eurekabookhouse.co.id
              </p>
            </div> -->

            <form
              data-toggle="validator"
              role="form"
              @submit.prevent="submitRegister"
            >
              <h5 class="title mb-4 text-center mt-3 mb-3 separator">
                1. Profil Toko
              </h5>
              <div class="form-group">
                <label for="name">Nama Toko</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  name="name"
                  placeholder="Nama Toko"
                />
              </div>
              <div class="form-row mt-3">
                <div class="form-group col-md-4">
                  <label for="jenisusaha" class="col">Jenis Usaha</label>

                  <select
                    class="form-control"
                    name="jenis_usaha"
                    id="jenis_usaha"
                    v-model="jenisUsaha"
                  >
                    <option disabled selected="">Pilih jenis usaha</option>
                    <option value="Individu">Individu</option>
                    <option value="PT">PT</option>
                    <option value="CV">CV</option>
                  </select>
                  <span class="help-block with-errors"></span>
                </div>
                <div class="form-group col-md-4">
                  <label for="kategori_usaha" class="col">Kategori Usaha</label>

                  <select
                    class="form-control"
                    name="kategori_usaha"
                    id="kategori_usaha"
                  >
                    <option disabled>Pilih Kategori Usaha</option>
                    <option value="1">Usaha Mikro</option>
                    <option value="2">Usaha Kecil</option>
                    <option value="3">Usaha Menengah</option>
                    <option value="4">Usaha Besar</option>
                    <option selected value="5">Non UMKM</option>
                    <option value="6">Koperasi</option>
                  </select>
                  <span class="help-block with-errors"></span>
                </div>
                <div class="form-group col-md-4">
                  <label for="status_usaha" class="col">Status Usaha</label>

                  <select class="form-control" name="jenis" id="jenis">
                    <option disabled>Pilih Status Usaha</option>
                    <option value="PKP">PKP</option>
                    <option selected value="Non-PKP">Non-PKP</option>
                  </select>
                  <span class="help-block with-errors"></span>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="npwp">NPWP</label>
                  <input
                    type="number"
                    class="form-control"
                    name="npwp"
                    placeholder="Masukan NPWP"
                    id="npwp"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="siup">SIUP/NIB</label>
                  <input
                    type="text"
                    class="form-control"
                    name="siup"
                    id="siup"
                    placeholder="Masukan SIUP"
                    @input="siupReq"
                  />
                  <div id="siupRequired" class="invalid-feedback"></div>
                </div>

                <div class="form-group col-md-12">
                  <label for="siup"
                    >Scan NPWP* Gunakan file gambar berekstensi .jpg, maksimum
                    ukuran 500kb</label
                  >
                </div>

                <input
                  type="file"
                  name="npwp_image"
                  id="npwp_image"
                  @change="loadImg()"
                  accept="image/*"
                />
              </div>
              <div class="mt-3" style="margin-left: -5px">
                <img
                  id="frame"
                  src="https://via.placeholder.com/100"
                  width="100px"
                  height="100px"
                />
              </div>
              <!-- <br />
              <div class="mb-5 col-md-6">
                <span class="h5"
                  >Apa tipe usaha anda (berdasarkan UU no 20 tahun 2008)?</span
                >

                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="UsahaMikro"
                    value="1"
                  />
                  <label class="form-check-label" for="UsahaMikro">
                    Usaha Mikro <br />
                    (Kekayaan bersih maksimal 50 juta — tidak termasuk tanah &
                    bangunan tempat usaha — , atau penghasilan maksimal 300
                    juta/ tahun)
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="UsahaKecil"
                    value="2"
                  />
                  <label class="form-check-label" for="UsahaKecil">
                    Usaha Kecil <br />
                    (Kekayaan bersih 50 juta - 500 juta—tidak termasuk tanah &
                    bangunan tempat usaha — , atau penghasilan 300 juta - 2,5
                    miliar/ tahun)
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="UsahaMenengah"
                    value="3"
                  />
                  <label class="form-check-label" for="UsahaMenengah">
                    Usaha Menengah <br />
                    (Kekayaan bersih 500 juta - 10 miliar —tidak termasuk tanah
                    & bangunan tempat usaha — , atau penghasilan 2,5 miliar- 50
                    miliar/ tahun)
                  </label>
                </div>

                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="UsahaBesar"
                    value="4"
                  />
                  <label class="form-check-label" for="UsahaBesar">
                    Usaha Besar <br />
                    (Kekayaan bersih usaha bersih di atas 10 miliar rupiah tidak
                    termasuk tanah dan bangunan tempat usaha serta dapat
                    menerima kredit dari bank di atas 5 miliar rupiah)
                  </label>
                </div>

                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="NonUMKM"
                    value="5"
                  />
                  <label class="form-check-label" for="NonUMKM">
                    Non UMKM
                  </label>
                </div>

                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="Koperasi"
                    value="6"
                  />
                  <label class="form-check-label" for="Koperasi">
                    Koperasi
                  </label>
                </div>
              </div> -->

              <h5 class="title mt-4 mb-4 text-center mt-3 mb-3 separator">
                2. Lokasi Toko
              </h5>

              <!-- <h5 class="text-center">LOKASI TOKO (BERDASARKAN GOOGLE MAP)*</h5> -->
              <div class="form-group">
                <label for="inputAddress2">Alamat Detail NPWP* :</label>
                <input
                  type="text"
                  class="form-control"
                  id="address_npwp"
                  name="address_npwp"
                  placeholder="Alamat NPWP"
                />
              </div>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="inputState">Provinsi*</label>
                  <select
                    id="provinceVal"
                    name="provinceVal"
                    class="form-control"
                    v-model="renderCity"
                  >
                    <option value="0" disabled selected>Pilih Provinsi</option>
                    <option
                      :value="prov.province_id"
                      v-for="(prov, index) in province"
                      :key="index"
                    >
                      {{ prov.province }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="inputState">Kota/Kabupaten* 061800</label>
                  <select
                    id="cityVal"
                    name="cityVal"
                    class="form-control"
                    v-model="renderKecamatan"
                  >
                    <option value="0" disabled selected>Pilih Kota</option>
                    <option
                      :value="city.city_id"
                      v-for="(city, index) in valCity"
                      :key="index"
                    >
                      {{ city.city_name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="inputState">Kecamatan* 061804</label>
                  <select
                    id="kecamatanVal"
                    class="form-control"
                    name="kecamatanVal"
                    v-model="renderKelurahan"
                  >
                    <option value="0" disabled selected>Pilih Kecamatan</option>
                    <option
                      :value="kec.subdistrict_kd"
                      :data="kec.subdistrict_id"
                      v-for="(kec, index) in valKecamatan"
                      :key="index"
                    >
                      {{ kec.subdistrict }}
                    </option>
                  </select>
                </div>

                <div class="form-group col-md-4">
                  <label for="inputState">Kelurahan*</label>
                  <select
                    id="kelurahanVal"
                    class="form-control"
                    name="kelurahanVal"
                  >
                    <option value="0" disabled selected>Pilih Kelurahan</option>
                    <option
                      :value="kel.kd_kelurahan_desa"
                      v-for="(kel, index) in valKelurahan"
                      :key="index"
                    >
                      {{ kel.kelurahan_desa }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="inputCity">Kode Pos :</label>
                  <input
                    type="number"
                    class="form-control"
                    id="kodepos"
                    name="kodepos"
                    placeholder="Masukkan Kode Pos"
                  />
                </div>
              </div>
              <!-- <div class="form-group">
                  <label for="inputAddress"
                    >Alamat berdasarkan (Google Map)* :</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="1234 Main St"
                  />
                </div> -->
              <div class="form-group">
                <label for="inputAddress"
                  >Drag Point Merah dibawah ini berdasarkan posisi Toko
                  Anda.</label
                >
              </div>

              <gmap-autocomplete
                class="introInput form-control"
                @place_changed="setPlace"
              >
                <template v-slot:input="slotProps">
                  <v-text-field
                    outlined
                    prepend-inner-icon="place"
                    placeholder="Location Of Event"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>
              <div class="text-center">
                <button
                  class="btn btn-secondary"
                  style="margin-top: -5px"
                  type="button"
                  @click="locatorButtonPressed"
                >
                  Lokasi Sekarang
                </button>
              </div>

              <GmapMap
                ref="mapRef"
                :center="center"
                :zoom="17"
                map-type-id="terrain"
                style="width: 100%; height: 400px"
              >
                <GmapMarker
                  v-for="(m, index) in markers"
                  :key="index"
                  :position="center"
                  :clickable="true"
                  :draggable="true"
                  @click="center = m.position"
                  @dragend="showLocation"
                />
              </GmapMap>
              <!-- <h5 class="text-center">LOKASI TOKO (BERDASARKAN NPWP)*</h5> -->
              <!-- <div id="googleMap" style="margin-top: 0px; z-index: 0"></div> -->

              <h5 class="title mt-4 mb-4 text-center mt-3 mb-3 separator">
                3. Penanggung Jawab Toko
              </h5>
              <div class="form-row mt-3">
                <div class="form-group col-md-4">
                  <label for="nama_pic">Nama PIC</label>
                  <input
                    type="text"
                    class="form-control"
                    id="nama_pic"
                    name="nama_pic"
                    placeholder="Nama PIC"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="jabatan_pic">Jabatan PIC</label>
                  <input
                    type="text"
                    class="form-control"
                    id="jabatan_pic"
                    name="jabatan_pic"
                    placeholder="Jabatan PIC"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="no_telp">No Telp</label>
                  <input
                    type="number"
                    class="form-control"
                    id="telp_pic"
                    name="telp_pic"
                    placeholder="No Telepon"
                  />
                </div>

                <div class="form-group col-md-6">
                  <label for="NIK">Nomor Induk Kependudukan (NIK)</label>
                  <input
                    type="number"
                    class="form-control"
                    name="NIK"
                    id="NIK"
                    placeholder="Masukan NIK"
                  />
                  <div id="nikRequired" class="invalid-feedback"></div>
                </div>
              </div>

              <h5 class="title mt-4 mb-4 text-center mt-3 mb-3 separator">
                4. Bank Toko
              </h5>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="inputState">Nama Bank*</label>
                  <select id="nama_bank" name="nama_bank" class="form-control">
                    <option
                      :value="bank.bank"
                      v-for="(bank, index) in bankArr"
                      :key="index"
                      selected=""
                    >
                      {{ bank.bank }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="inputState">Cabang Bank*</label>
                  <input
                    type="text"
                    class="form-control"
                    id="cabang"
                    name="cabang"
                    placeholder="Masukkan Cabang Bank"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="inputState">Nomor Rekening *</label>
                  <input
                    type="text"
                    class="form-control"
                    id="nomor_rekening"
                    name="nomor_rekening"
                    placeholder="Masukkan Nomor Rekening"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="inputState">Bank Holder *</label>
                  <input
                    type="text"
                    class="form-control"
                    name="atas_nama"
                    id="atas_nama"
                    placeholder="Atas Nama Bank"
                  />
                </div>
              </div>
              <h5 class="title mt-4 mb-4 text-center mt-3 mb-3 separator">
                5. Login Pengguna
              </h5>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="inputState">Email Toko*</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    name="email"
                    placeholder="example@gmail.com"
                  />
                  <!-- <p
                    id="length"
                    class="invalid"
                    style="margin-top: 0%; margin-left: 2%"
                  >
                    Minimal <b>10 karakter</b>
                  </p>
                  <p
                    id="letter"
                    class="invalid"
                    style="margin-top: -2%; margin-left: 2%"
                  >
                    Berisi minimal<b> 1 huruf kecil</b>
                  </p>
                  <p
                    id="capital"
                    class="invalid"
                    style="margin-top: -2%; margin-left: 2%"
                  >
                    Berisi minimal<b> 1 huruf besar</b>
                  </p>
                  <p
                    id="number"
                    class="invalid"
                    style="margin-top: -2%; margin-left: 2%"
                  >
                    Berisi minimal<b> 1 angka</b>
                  </p> -->
                </div>
                <div class="form-group col-md-4">
                  <label for="inputState">Password*</label>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    placeholder="*******"
                    name="password"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="inputState">Password Konfirmasi*</label>
                  <input
                    type="password"
                    class="form-control"
                    id="password_konfirmasi"
                    name="password_konfirmasi"
                    placeholder="*******"
                  />
                  <div class="invalid-feedback">Password tidak cocok</div>
                  <div class="valid-feedback"></div>
                </div>
              </div>
              <div>
                <input
                  type="checkbox"
                  name="pernyataan"
                  v-model="isAgree"
                  id="pernyataan"
                />
                Saya Setuju terhadap
                <u>
                  <a
                    href="https://siplah.eurekabookhouse.co.id/syarat-dan-ketentuan-siplah-eurekabookhouse-kemendikbud"
                    target="_blank"
                  >
                    Ketentuan Umum dan Persetujuan Penyedia</a
                  >
                </u>
              </div>
              <div>
                <div class="row">
                  <div class="col-md-6">
                    <button
                      :disabled="!isAgree"
                      type="submit"
                      class="btn btn-block login-btn mb-4 col-md-12"
                      style="height: 50px"
                    >
                      Daftar
                    </button>
                  </div>

                  <div class="col-md-6">
                    <button
                      type="button"
                      class="btn btn-block bg-default login-btn mb-4 col-md-12"
                      style="height: 50px"
                      @click="goBack"
                    >
                      Batal
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  </body>
</template>

<script>
// import VueButtonSpinner from 'vue-button-spinner';
import $ from "jquery";
// import axios from "axios";
// import {
//   sleeper
// } from "../utils/sleeper";

import { gmapApi } from "vue2-google-maps";
// import NProgress from "nprogress";
import axios from "axios";

export default {
  components: {
    // VueButtonSpinner
  },
  data() {
    return {
      province: [],
      bankArr: [],
      renderCity: 0,
      valCity: [],
      renderKecamatan: 0,
      valKecamatan: [],
      renderKelurahan: 0,
      valKelurahan: [],
      form: {
        email: "",
        password: "",
      },
      errors: null,
      center: {
        lat: -6.3201981,
        lng: 106.8711803,
      },
      markers: [
        {
          position: {
            lat: -6.3201981,
            lng: 106.8711803,
          },
        },
      ],
      places: [],
      latLng: {},
      isAgree: false,
      agreement: "off",
      locations: [],
      formatedAddresses: [],
      locatorLat: "",
      locatorLng: "",
      jenisUsaha: "Individu",
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    jenisUsaha() {
      if (
        (this.jenisUsaha === "PT" && $("#siup").val() === "") ||
        (this.jenisUsaha === "CV" && $("#siup").val() === "")
      ) {
        $("#siup").addClass("is-invalid");
        $("#siupRequired").text("SIUP/NIB Wajib diisi");
      } else {
        $("#siup").removeClass("is-invalid");
      }
    },
    renderCity() {
      this.getCity();
    },
    renderKecamatan() {
      this.getKecamatan();
    },
    renderKelurahan() {
      this.getKelurahan();
    },
    isAgree() {
      if (this.isAgree) {
        this.agreement = "on";
      } else {
        this.agreement = "off";
      }
    },
  },
  mounted() {
    this.getProvince();
    this.validationPassword();
    this.forDisplay();
  },
  created() {
    this.geocodedAddress(-6.3201981, 106.8711803);
    // this.loadImg();
  },
  methods: {
    loadImg() {
      const fileSize =
        document.getElementById("npwp_image").files[0].size / 1024 / 1024; // in MiB
      if (fileSize.toFixed(1) > 1) {
        alert("File Terlalu Besar! Maksimal Upload 1 Mb");
        $("#npwp_image").addClass("file-danger");
      } else {
        $("#npwp_image").removeClass("file-danger");
        $("#frame").attr("src", URL.createObjectURL(event.target.files[0]));
      }
    },
    siupReq() {
      if ($("#siup").val() !== "") {
        $("#siup").removeClass("is-invalid");
        $("#siupRequired").text("SIUP/NIB Wajib diisi");
      }

      if (
        (this.jenisUsaha === "PT" && $("#siup").val() === "") ||
        (this.jenisUsaha === "CV" && $("#siup").val() === "")
      ) {
        $("#siup").addClass("is-invalid");
        $("#siupRequired").text("SIUP/NIB Wajib diisi");
      } else {
        $("#siup").removeClass("is-invalid");
      }
    },
    locatorButtonPressed() {
      // console.log(this.markers[0].position.lat)
      // console.log(this.markers[0].position.lng)
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.geocodedAddress(
            position.coords.latitude,
            position.coords.longitude
          );
          this.center.lat = position.coords.latitude;
          this.center.lng = position.coords.longitude;
          // this.markers[0].position.lat = position.coords.latitude
          // this.markers[0].position.lng = position.coords.longitude
          // this.locatorLat = position.coords.latitude
          // this.locatorLng = position.coords.longitude
        },
        (error) => {
          console.log(error.message);
        }
      );
    },
    setPlaceText(place) {
      this.place = place;
    },
    setPlace(place) {
      this.center.lat = place.geometry.location.lat();
      this.center.lng = place.geometry.location.lng();
      this.locatorLat = place.geometry.location.lat();
      this.locatorLng = place.geometry.location.lng();

      this.latLng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
    },
    geocodedAddress(lat, lon) {
      $.getJSON(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          lon +
          "&sensor=false&key=AIzaSyB4C8a6rkM6BKu1W0owWvStPzGHoc4ZBXI",
        function(data) {
          var adress = data.results[0].formatted_address;
          $(".introInput ").val(adress);
        }
      );
    },
    showLocation(evt) {
      this.locatorLat = evt.latLng.lat();
      this.locatorLng = evt.latLng.lng();
      this.center.lat = evt.latLng.lat();
      this.center.lng = evt.latLng.lng();
      this.geocodedAddress(this.locatorLat, this.locatorLng);
    },
    submitRegister() {
      try {
        document.getElementById("npwp_image").files[0].name;
      } catch (error) {
        this.$toast.error(`Foto NPWP tidak boleh kosong!`);
      }

      if (document.getElementById("npwp").value.length != 16) {
        this.$toast.error(`NPWP Harus 16 Digit!`);
      } else if (document.getElementById("name").value === "") {
        this.$toast.error(`Nama Toko tidak boleh kosong`);
      } else if (
        (this.jenisUsaha === "PT" && $("#siup").val() === "") ||
        (this.jenisUsaha === "CV" && $("#siup").val() === "")
      ) {
        this.$toast.error(`Siup tidak boleh kosong`);
      } else if (document.getElementById("address_npwp").value === "") {
        this.$toast.error(`Alamat NPWP tidak boleh kosong`);
      } else if ($("#provinceVal").val() === null) {
        this.$toast.error(`Silahkan pilih Provinsi`);
      } else if ($("#cityVal").val() === null) {
        this.$toast.error(`Silahkan pilih Kota`);
      } else if ($("#kecamatanVal").val() === null) {
        this.$toast.error(`Silahkan pilih Kecamatan`);
      } else if ($("#kelurahanVal").val() === null) {
        this.$toast.error(`Silahkan pilih Kelurahan`);
      } else if ($("#kodepos").val() === "") {
        this.$toast.error(`Kode Pos tidak boleh kosong`);
      } else if ($(".introInput").val() === "") {
        this.$toast.error(`Alamat berdasarkan Google Maps tidak boleh kosong`);
      } else if (document.getElementById("nama_pic").value === "") {
        this.$toast.error(`Nama PIC tidak boleh kosong`);
      } else if (document.getElementById("jabatan_pic").value === "") {
        this.$toast.error(`Jabatan PIC tidak boleh kosong`);
      } else if (document.getElementById("telp_pic").value === "") {
        this.$toast.error(`Telepon PIC tidak boleh kosong`);
      } else if (document.getElementById("NIK").value === "") {
        this.$toast.error(`NIK tidak boleh kosong`);
      } else if (document.getElementById("nomor_rekening").value === "") {
        this.$toast.error(`Nomor Rekening tidak boleh kosong`);
      } else if (document.getElementById("cabang").value === "") {
        this.$toast.error(`Cabang Bank tidak boleh kosong`);
      } else if (document.getElementById("atas_nama").value === "") {
        this.$toast.error(`Bank Holder tidak boleh kosong`);
      } else if (document.getElementById("email").value === "") {
        this.$toast.error(`Email tidak boleh kosong`);
      } else if (document.getElementById("password").value === "") {
        this.$toast.error(`Password tidak boleh kosong`);
      } else if (document.getElementById("password_konfirmasi").value === "") {
        this.$toast.error(`Konfirmasi Password tidak boleh kosong`);
      } else if ($("#password_konfirmasi").hasClass("is-invalid")) {
        this.$toast.error(`Konfirmasi Password belum cocok`);
      } else {
        // console.log(document.getElementById("kelurahan").text);
        var radioValue = $("input[name='flexRadioDefault']:checked").val();
        var indexForKecamatan = document.getElementById("kecamatanVal")
          .selectedIndex;
        var resForKecVal = document.getElementById("kecamatanVal").options[
          indexForKecamatan
        ].attributes.data.value;

        var indexForKelurahan = document.getElementById("kelurahanVal")
          .selectedIndex;

        var resForKelName = document.getElementById("kelurahanVal").options[
          indexForKelurahan
        ].text;
        // console.log(document.getElementById("province").value);
        var myHeaders = new Headers();
        myHeaders.append(
          "Cookie",
          "ci_session=cbnl1q3dut6fksccmpdmf69iqkg349r7"
        );

        var formdata = new FormData();
        formdata.append("type_reg", "bh");
        formdata.append("name", document.getElementById("name").value);
        formdata.append(
          "jenis_usaha",
          document.getElementById("jenis_usaha").value
        );
        formdata.append(
          "kategori_usaha",
          document.getElementById("kategori_usaha").value
        );
        formdata.append("jenis", document.getElementById("jenis").value);
        formdata.append("npwp", document.getElementById("npwp").value);
        formdata.append("siup", document.getElementById("siup").value);
        formdata.append(
          "npwp_image",
          document.getElementById("npwp_image").files[0],
          document.getElementById("npwp_image").files[0].name
        );
        formdata.append("zone_2", " ");
        formdata.append("postcode", " ");
        formdata.append("country", " ");
        formdata.append("location", " ");
        formdata.append(
          "address_npwp",
          document.getElementById("address_npwp").value
        );
        formdata.append(
          "province",
          document.getElementById("provinceVal").value
        );
        formdata.append("city", document.getElementById("cityVal").value);
        formdata.append("kecamatan", resForKecVal);
        formdata.append("kodepos", document.getElementById("kodepos").value);
        formdata.append(
          "kelurahan_kd",
          document.getElementById("kelurahanVal").value
        );
        formdata.append("kelurahan_nama", resForKelName);
        formdata.append(
          "address_1",
          document.getElementsByClassName("introInput")[0].value
        );
        formdata.append("lat", this.center.lat);
        formdata.append("lon", this.center.lng);
        formdata.append("nama_pic", document.getElementById("nama_pic").value);
        formdata.append(
          "jabatan_pic",
          document.getElementById("jabatan_pic").value
        );
        formdata.append("telp_pic", document.getElementById("telp_pic").value);
        formdata.append("ktp_id", document.getElementById("NIK").value);
        formdata.append(
          "nama_bank",
          document.getElementById("nama_bank").value
        );
        formdata.append("cabang", document.getElementById("cabang").value);
        formdata.append(
          "nomor_rekening",
          document.getElementById("nomor_rekening").value
        );
        formdata.append(
          "atas_nama",
          document.getElementById("atas_nama").value
        );
        formdata.append("email", document.getElementById("email").value);
        formdata.append("password", document.getElementById("password").value);
        formdata.append(
          "password_konfirmasi",
          document.getElementById("password_konfirmasi").value
        );
        formdata.append(
          "pernyataan",
          document.getElementById("pernyataan").value
        );
        formdata.append("mall_type", radioValue);

        // for (var pair of formdata.entries()) {
        //   console.log(pair[0] + ", " + pair[1]);
        // }

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        this.$swal
          .fire({
            title: "Anda yakin?",
            text: "Bahwa data yang anda masukkan sudah benar",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              fetch(
                "https://siplah.eurekabookhouse.co.id/staging/backendseller/registration_api/process",
                requestOptions
              )
                .then((response) => response.json())
                .then((result) => {
                  if (
                    result.success === false ||
                    result.type === "email_already" ||
                    result.type === "merchant_already" ||
                    result.type === "upload_failed"
                  ) {
                    this.$toast.error(`${result.title}`);
                  } else {
                    setTimeout(() => {
                      this.$router.push({
                        path: "/login",
                      });
                      this.$toast.success(`${result.title}`);
                    }, 550);
                  }
                })
                .catch((error) => alert("error", error));
            }
          });
      }
    },
    filterBank(bank) {
      return bank.id_bank != 39 && bank.id_bank != 35 && bank.id_bank != 33;
    },
    getProvince() {
      axios
        .get(
          `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/reg3`
        )
        .then((res) => {
          return res.data;
        })
        .then((data) => {
          this.province = data.prov;
          let bankList = data.bank;
          this.bankArr = bankList.filter(this.filterBank);
        });
    },
    getCity() {
      axios
        .get(
          `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/getCity/${this.renderCity}?ids=${this.renderCity}`
        )
        .then((res) => {
          return res.data;
        })
        .then((data) => {
          // console.log(data);
          this.valCity = data;
        });
    },
    getKecamatan() {
      axios
        .get(
          `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/getKecamatan/${this.renderKecamatan}?ids=${this.renderKecamatan}`
        )
        .then((res) => {
          // console.log(res.data);
          return res.data;
        })
        .then((data) => {
          // console.log(data);
          this.valKecamatan = data;
        });
    },
    getKelurahan() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=6atpcf73eddl9rq27vtac897i8rc4goc");

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/getKelurahan/${this.renderKelurahan}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.valKelurahan = result;
        })
        .catch((error) => console.log("error", error));
    },
    validationPassword() {
      var myInput = document.getElementById("password");
      var confirmPass = document.getElementById("password_konfirmasi");
      var letter = document.getElementById("letter");
      var capital = document.getElementById("capital");
      var number = document.getElementById("number");
      var length = document.getElementById("length");
      confirmPass.onkeyup = () => {
        // const valPass = $('.password').val()
        // const valConfirmPass = $('.confirmPass').val()
        if (confirmPass.value === myInput.value) {
          $("#password_konfirmasi").addClass("is-valid");
        } else {
          $("#password_konfirmasi").removeClass("is-valid");
        }

        if (confirmPass.value !== myInput.value) {
          $("#password_konfirmasi").addClass("is-invalid");
        } else {
          $("#password_konfirmasi").removeClass("is-invalid");
        }
      };
      myInput.onkeyup = function() {
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if (myInput.value.match(lowerCaseLetters)) {
          letter.classList.remove("invalid");
          letter.classList.add("valid");
        } else {
          letter.classList.remove("valid");
          letter.classList.add("invalid");
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if (myInput.value.match(upperCaseLetters)) {
          capital.classList.remove("invalid");
          capital.classList.add("valid");
        } else {
          capital.classList.remove("valid");
          capital.classList.add("invalid");
        }
        // Validate numbers
        var numbers = /[0-9]/g;
        if (myInput.value.match(numbers)) {
          number.classList.remove("invalid");
          number.classList.add("valid");
        } else {
          number.classList.remove("valid");
          number.classList.add("invalid");
        }

        // Validate length
        if (myInput.value.length >= 10) {
          length.classList.remove("invalid");
          length.classList.add("valid");
        } else {
          length.classList.remove("valid");
          length.classList.add("invalid");
        }
      };
    },
    goBack() {
      this.$swal
        .fire({
          title: "Anda yakin?",
          text: "Ingin membatalkan form pendaftaran sebagai penjual",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    forDisplay() {
      const matchSize = window.screen.availWidth;

      if (matchSize < 768) {
        $("#pictureOffice").hide();
      } else {
        $("#pictureOffice").show();
      }
      $(window).on("resize", function() {
        if ($(window).width() < 768) {
          $("#pictureOffice").hide();
        } else {
          $("#pictureOffice").show();
        }
      });
    },
    validateSize(input) {
      const fileSize = input.files[0].size / 512 / 512; // in MiB
      console.log(fileSize);
      // if (fileSize > 2) {
      //   alert('File size exceeds 2 MiB');
      //   // $(file).val(''); //for clearing with Jquery
      // } else {
      //   // Proceed further
      // }
    },
  },
};
</script>

<style scoped>
.file-danger {
  color: red;
  border: red solid 1px;
}
.auth-logo {
  display: block;
  margin: -70px 0px 0px -25px;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.profile-user-wid {
  margin-top: -26px;
}

.rounded-circle {
  border-radius: 50% !important;
}

.bg-light {
  background-color: #eff2f7 !important;
}

img,
svg {
  vertical-align: middle;
}

.avatar-title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #556ee6;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  height: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;
}
.bg-primary.bg-soft {
  background-color: rgba(85, 110, 230, 0.25) !important;
}
.align-self-end {
  -ms-flex-item-align: end !important;
  align-self: flex-end !important;
}
#message p {
  padding: 0px 15px;
  font-size: 14px;
}

.valid {
  color: rgb(57, 136, 57);
}

.valid:before {
  position: relative;
  left: -15px;
  content: "✓";
}

.invalid {
  color: rgb(192, 55, 55);
}

.invalid:before {
  position: relative;
  left: -15px;
  content: "✖";
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 0.35px solid rgb(209, 209, 209);
}

.separator:not(:empty)::before {
  margin-right: 0.7em;
}

.separator:not(:empty)::after {
  margin-left: 0.7em;
}

body {
  /* font-family: "Karla", sans-serif; */
  background-color: #f8f8fb;
  min-height: 100vh;
}

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  max-width: 700px;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.login-card {
  border: 0;
  border-radius: 10px;
  background-color: #f7fafc !important;
  box-shadow: 0 10px 30px 0 rgba(172, 168, 168, 0.43);
  overflow: hidden;
  margin: 10% 0px 10% 0px;
}

.login-card-img {
  border-radius: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.login-card .card-body {
  padding: 3rem 3rem 3rem;
}

.brand-wrapper {
  margin-bottom: 19px;
}

.brand-wrapper .logo {
  height: 37px;
}

.login-card-description {
  font-size: 22.5px;
  color: #000;
  font-weight: normal;
  margin-bottom: 23px;
}

/* .login-card form {
    max-width: 326px;
} */

/* .login-card .form-control {
  border: 1px solid #d5dae2;
  padding: 0px 0px 0px 12.5px;
  margin-bottom: 20px;
  min-height: 45px;
  font-size: 13px;
  line-height: 15;
  font-weight: normal;
} */
.login-card .form-control {
  border: 0;
  /* padding: 15px 25px; */
  margin-bottom: 20px;
  background-color: #fff !important;
  color: #8898aa !important;
  min-height: 45px;
  font-size: 13px;
  /* line-height: 15; */
  font-weight: normal;
  /* color: black !important; */
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}
.login-card .login-btn {
  padding: 13px 20px 12px;
  background-color: #2a3042;
  border-radius: 4px;
  font-size: 15px;
  font-weight: bold;
  line-height: 20px;
  color: #fff;
  margin-bottom: 24px;
}

.login-card .forgot-password-link {
  font-size: 14px;
  color: #919aa3;
  margin-bottom: 12px;
}

.login-card-footer-text {
  font-size: 16px;
  color: #0d2366;
  margin-bottom: 60px;
}

.login-card-footer-nav a {
  font-size: 14px;
  color: #919aa3;
}

/* .card {
  box-shadow: 0 10px 30px 0 transparent;
} */

.is-invalid {
  border: 1px solid rgb(226, 97, 97) !important;
}
</style>
